/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Flow_No_ResultsInputs */

const en_task_flow_no_results = /** @type {(inputs: Task_Flow_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No results`)
};

const pt_br2_task_flow_no_results = /** @type {(inputs: Task_Flow_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum resultado`)
};

/**
* | output |
* | --- |
* | "No results" |
*
* @param {Task_Flow_No_ResultsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_flow_no_results = /** @type {((inputs?: Task_Flow_No_ResultsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Flow_No_ResultsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_flow_no_results(inputs)
	return pt_br2_task_flow_no_results(inputs)
});